import { Component, OnInit,Input,Output,EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RandomExpertsService } from "@shared/components/score/random-experts/random-experts.service";

@Component({
  selector: 'app-random-experts',
  templateUrl: './random-experts.component.html',
  styles: []
})
export class RandomExpertsComponent implements OnInit {
  @Input()randomExpertsVisibile:boolean;
  @ViewChild('randomExpertsForm') randomExpertsForm: NgForm;
  @Output() private nzOk = new EventEmitter();
  @Output() private nzCancel = new EventEmitter();
  public expertNum:any;
  constructor(private randomExpertsService:RandomExpertsService) { }
  handleCancel(){
    this.expertNum = null;
    this.nzCancel.emit();
  };
  handOk(){
    for (let item in this.randomExpertsForm.controls) {
      this.randomExpertsForm.controls[item].markAsDirty();
      this.randomExpertsForm.controls[item].updateValueAndValidity();
    }
    if (!this.randomExpertsForm.valid) {
      return;
    }
    this.randomExpertsService.get(this.expertNum).subscribe((data) =>{
      this.expertNum = null;
      this.nzOk.emit(data);
    });
  };
  ngOnInit() {
  }

}
